module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D03-clean-fcce3290daf951395c281b626e3b68f7.png";